import DeleteQuestionCollectionModal from './DeleteQuestionCollection';
export default DeleteQuestionCollectionModal;
